/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Equipment
 */
export interface Equipment {
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    imageId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Equipment
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Equipment
     */
    hasWeight?: boolean;
}

/**
 * Check if a given object implements the Equipment interface.
 */
export function instanceOfEquipment(value: object): value is Equipment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function EquipmentFromJSON(json: any): Equipment {
    return EquipmentFromJSONTyped(json, false);
}

export function EquipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Equipment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'hasWeight': json['hasWeight'] == null ? undefined : json['hasWeight'],
    };
}

export function EquipmentToJSON(json: any): Equipment {
    return EquipmentToJSONTyped(json, false);
}

export function EquipmentToJSONTyped(value?: Equipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'isPublic': value['isPublic'],
        'hasWeight': value['hasWeight'],
    };
}

